import React from 'react'
import { useSelector } from 'react-redux'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const SavedContainer = ({ openPage }) => {
  const { inchat: { savedMessage = 0 } } = useSelector(store => store)

  return (
    <div className='inchat-container inchat-saved-container'>
      <div className='inchat-container__header' onClick={() => openPage('saved')}>
        <img src={getStaticImage('/icons/orange-brand/icon-saved-primary.svg')} alt='saved' />
        <span className='inchat-container__title'>{lang('inchat_saved')}</span>
        { savedMessage > 0 &&
          <div className='inchat-container__count'>
            <span>{savedMessage}</span>
          </div>
        }
      </div>
    </div>
  )
}

export default SavedContainer
